module.exports = {
  and: require('./and'),
  ifElse: require('./ifElse'),
  implies: require('./implies'),
  not: require('./not'),
  or: require('./or'),
  unless: require('./unless'),
  when: require('./when')
}
